exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/React/Antique/src/app/shopping-cart-summary/shopping-cart-summary.component.css
// module id = ../../../../../src/app/shopping-cart-summary/shopping-cart-summary.component.css
// module chunks = 1